import { render, staticRenderFns } from "./phoneBasic.vue?vue&type=template&id=da99e6da&scoped=true&"
import script from "./phoneBasic.vue?vue&type=script&lang=js&"
export * from "./phoneBasic.vue?vue&type=script&lang=js&"
import style0 from "./phoneBasic.vue?vue&type=style&index=0&id=da99e6da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da99e6da",
  null
  
)

export default component.exports